import React, { useState, useEffect } from 'react'
import { Col, Container, Row,Button } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import { CanpaignRevenue, getcatorylist, getuserdaily,
    getusermonthly,
    getusercustom, } from '../../actions/users';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"
import axios from 'axios';
import DatePicker from "react-datepicker";
import config from "../../lib/config";
import { network } from "../AdminNetwork"
import Web3 from 'web3';
import { useDispatch, useSelector } from 'react-redux';

const Domains = () => {
    const [Accounts, Set_Accounts] = useState('0x0e3B697DD97418296d5291034E026124986f80C7')
    const [choose, setchoose] = useState();
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [searchQuery, setSearchQuery] = React.useState("");
    const [hidden, sethidden] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setendDate] = useState(new Date());
    const [userdet, setUser] = useState();
    const [USDPriceETH, setUSDPrice1ETH] = useState(0);
    const [USDPrice, setUSDPrice] = useState(0);
    const [USDPriceCAM,setUSDPriceCAM] = useState(config.CAM_USD)
    const [ShowHideDiv, setShowHideDiv] = useState(false);
    const [viewDetails, setViewDeatils] = useState()
    const [Totalvalue, SetTotalValue] = useState(0)
    const [Totalvalue1, SetTotalValue1] = useState(0)
    const [Totalvalue2, SetTotalValue2] = useState(0)
    const [Totalvaluefinal, SetTotalValuefinal] = useState(0)
    const [exportdata, setExportdata] = useState([])
    const [Balance ,setBalance] = useState(0) 
    const columns = [
        {
            key: "ind",
            text: "SNO",
            className: "name",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => <p>{index + 1}</p>,
        },
        {
            key: "domainname",
            text: "Domain Name",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "name",
            text: "Name",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "curraddress",
            text: "Address",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "signemail",
            text: "Mail",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "Publish",
            text: "Publish Status",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "Date",
            text: "Created Date",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "Claims",
            text: "View Details",
            className: "Plans",
            align: "left",
            sortable: false,
            cell: (record) => (
                <div>
                    <p className="subs_tbl_plan_txt plans_color view_details" onClick={() => ClickShowPlans(record?.Claims)}>View Details</p>
                </div>
            ),
        },
        
    ];

    const columns1 = [
        {
            key: "ind",
            text: "SNO",
            className: "name",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => <p>{index + 1}</p>,
        },
        {
            key: "claimer",
            text: "Claimer Address",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "tokenID",
            text: "tokenID",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "NetWork",
            text: "NetWork",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "GasAount",
            text: "GasAount",
            className: "Name",
            align: "left",
            sortable: false,
        },
        {
            key: "",
            text: "USD",
            className: "Name",
            align: "left",
            sortable: false,
            cell: (record) => (
                <div>{record.NetWork == config.ETH_ID ? (record.GasAount * USDPriceETH).toFixed(6) : record.NetWork == config.CAM_ID ?  (record.GasAount) : (record.GasAount * USDPrice).toFixed(6)} $</div>
            ),
        },
        {
            key: "Date",
            text: "Created Date",
            className: "Name",
            align: "left",
            sortable: false,
        },
    ];
    const ClickShowPlans = async (data) => {
        if (data?.length > 0) {
            setShowHideDiv(true)
            setViewDeatils(data)
            var ddd = data?.map(({ _id, __v, id, ...rest }) => {
                return rest
            })
            setExportdata(ddd)
            var mapdatapolygon = data.length > 0 && data.map((it, i) => it.NetWork == config.MATIC_ID ? it.GasAount : 0
            ).reduce((prev, curr) => prev + curr, 0);
            var mapdataeth = data.length > 0 && data.map((it, i) => it.NetWork == config.ETH_ID ? it.GasAount : 0
            ).reduce((prev, curr) => prev + curr, 0);
            var mapdatacam = data.length > 0 && data.map((it, i) => it.NetWork == config.CAM_ID_ID ? it.GasAount : 0
            ).reduce((prev, curr) => prev + curr, 0);
            var usdPoly = mapdatapolygon !== 0 ? mapdatapolygon * USDPrice : 0
            var usdEth = mapdataeth !== 0 ? mapdataeth * USDPriceETH : 0
            var usdCam = mapdatacam !== 0 ? mapdatacam * USDPriceCAM  : 0
            var finalvalue = usdPoly + usdEth + usdCam
            SetTotalValue(usdPoly)
            SetTotalValue1(usdEth)
            SetTotalValue2(usdCam)
            SetTotalValuefinal(finalvalue)
        } else {
            toastAlert("error", "Details Not Found")
        }
    };


    const EthereumPrice = () => {
        var varname = "ETH"
        axios
            .get(
                `https://min-api.cryptocompare.com/data/price?fsym=${varname}&tsyms=USD`
            )
            .then((result) => {
                console.log("Api Success BNBB", result, result.data.USD);
                if (result.data && result.data.USD && result.data.USD) {
                    var Price = result.data.USD;
                    setUSDPrice1ETH(Number(Price));

                }
            })
            .catch((error) => {
                console.log("Api Overloaded", error);
            });
    };

    const BNBprice = () => {
        var varname = "MATIC"
        axios
            .get(
                `https://min-api.cryptocompare.com/data/price?fsym=${varname}&tsyms=USD`
            )
            .then((result) => {
                if (result.data && result.data.USD && result.data.USD) {
                    var Price = result.data.USD;
                    setUSDPrice(Number(Price));
                }
            })
            .catch((error) => {
                console.log("Api Overloaded", error);
            });
    };


    useEffect(() => {
        getCatorylist();
        EthereumPrice();
        BNBprice()
    }, []);

    const startdatechange = async (event) => {
        setStartDate(event);
        var data = {
            startdate: event,
            enddate: endDate,
        };
        var test = await getusercustom(data);
        setUser(test.userValue);
    };

    const enddatechange = async (event) => {
        setendDate(event);
        var data = {
            startdate: startDate,
            enddate: event,
        };
        var test = await getusercustom(data);
        setUser(test.userValue);
    };

    const getCatorylist = async () => {
        var test = await CanpaignRevenue();
        console.log("sdfdaasas", test);
        if (test.status == true) {
            setUser(test.Datas);
            var ddd = test.Datas.map(({ _id, __v, id, ...rest }) => {

                return rest
            })
            setExportdata(ddd)
        }
    };

    const changeNetwork = async () => {
        if (window.ethereum.isMetaMask == true) {
            var web3 = new Web3(window.ethereum);
            var web3Obj = await SwitchNetwork();
            const accounts = await web3Obj.eth.getAccounts();
        }
    };

    async function SwitchNetwork() {
        var web3;
        try {
            if (window.ethereum) {
                web3 = new Web3(window.ethereum);
                if (window.ethereum.isMetaMask == true) {
                    const chainId1 = await web3.eth.getChainId();
                    const chainId = parseInt(chainId1)
                    var configchainid = chainId === network.ETH.Chainid
                    ? network.MATIC.Chainid 
                    : chainId === network.MATIC.Chainid ? network.CAM.Chainid : network.ETH.Chainid;
                    if (parseInt(chainId) != parseInt(configchainid)) {
                        chainIdCheck(configchainid);
                        return web3;
                    }
                } else {
                    alert("Please Uninstall CoinbaseWallet or Connect to Coinbase");
                    return false;
                }
            } else {
            }
        } catch (e) { }
        return web3;
    }

    const chainIdCheck = async (configchainid) => {
        var Config = {};

        if (configchainid === network.MATIC.Chainid) {
            Config = network.MATIC;
        } else if (configchainid === network.ETH.Chainid) {
            Config = network.ETH;
        } else if (configchainid === network.CAM.Chainid) {
            Config = network.CAM;
        }

        const hexString = configchainid && configchainid.toString(16);
        if (window.ethereum) {
            try {

                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
                });

                var coinBalance = await window.web3.eth.getBalance(Accounts);
        const convertCoin =  parseInt(coinBalance) /1e18
        setBalance(convertCoin?.toFixed(5));
                return true;
            } catch (error) {
                // This error code indicates that the chain has not been added to MetaMask
                // if it is not, then install it into the user MetaMask
                if (error.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                {
                                    chainId: "0x" + hexString,
                                    rpcUrl: Config.RPC_URL,
                                },
                            ],
                        });
                        return true;
                    } catch (addError) {
                        console.error(addError);
                    }
                }
                console.error(error);
            }
        } else {
            // if no window.ethereum then MetaMask is not installed
            return false;
        }
    };

    useEffect(() => {
        getConnect();
    }, [])

    const getConnect = async () => {
        try {
            var configdata = {};
            if (window.ethereum) {
                var web3 = new Web3(window.ethereum);
                if (web3 !== undefined) {
                    await window.ethereum.enable().then(async function () {
                        const web3 = new Web3(window.web3.currentProvider);
                        if (window.web3.currentProvider.networkVersion === config.ETH_ID) {
                            var currentChainId = network.ETH.Chainid;
                            configdata = network.ETH;
                        } else if (window.web3.currentProvider.networkVersion === config.MATIC_ID) {
                            var currentChainId = network.MATIC.Chainid;
                            configdata = network.MATIC;
                        } else if (window.web3.currentProvider.networkVersion === config.CAM_ID) {
                            var currentChainId = network.CAM.Chainid;
                            configdata = network.CAM;
                        }
                        
                        if (window.web3.currentProvider.networkVersion == currentChainId) {
                            if (window.web3.currentProvider.isMetaMask === true) {
                                var currAddr1 = await web3.eth.getAccounts();
                                    var CurAddr = currAddr1[0].toLowerCase();
                                if (
                                    window.web3 &&
                                    CurAddr) {
                      
                                var coinBalance = await web3.eth.getBalance(Accounts);
                        const convertCoin =  parseInt(coinBalance) /1e18
                        setBalance(convertCoin?.toFixed(5));
                                }
                            }
                        } else {
                            toastAlert("upload", "Please Connect Wallet");
                        }
                    });
                }
            }
        } catch (errr) {
            console.log("get connect", errr);
        }
    };

    const configdata = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",

        language: {
            length_menu: "Show _MENU_ result per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: <> Previous </>,
                next: <>Next</>,
                last: "Last",
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };
  return (
  
          <>
              {ShowHideDiv == false ?
                  <>
                    <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
                          <Row>
            <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
            </Col>
            <Col  xl={10} lg={12}>
            <Header title={'Campaign Created List'}/>



            <div className="common_page_scroller mt-5 pe-2">

<div className='d-block d-sm-flex justify-content-between align-items-center'>
    <div>
<p className='text-white'><span className='redclrs'>Fee : </span>{Accounts != "" ? Accounts?.toLowerCase() : "Connect"}</p>
<p className='text-white'><span className='redclrs'>Bal : </span> {Balance}</p>
</div>
<div className='bottom_btn_comp my-0'>
  <button type='button' className='btn bottom_btn' onClick={() => changeNetwork()}>Switch network</button>
</div>
</div>


            <div className="page_header">
        </div>
           
            </div>
                      <div className={" categoryds "}>
                          <div className="page_header">
                              <div>
                                  {hidden && (
                                      <span>
                                          <DatePicker
                                              selected={startDate}
                                              onChange={startdatechange}
                                              className="mr-4"
                                          />
                                          <DatePicker
                                              selected={endDate}
                                              onChange={enddatechange}
                                              className="mr-3"
                                          />
                                      </span>
                                  )}
                                     </div>
                          </div>
  
                          <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                    config={configdata}
                    records={userdet}
                    columns={columns}
                />
                </div>
                          <div className="bottom_btn_comp">
                              <Exportexcel excelData={exportdata} fileName={'users'} />
                              <Exportpdf pdfData={exportdata} fileName={'users'} />
                              <Exportcsv csvData={exportdata} fileName={'users'} />
                          </div>
                      </div>
                      </Col>
        </Row>
        </Container>
                  </>
                  :
                  <>
                    <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
            <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
            </Col>
            <Col  xl={10} lg={12}>
            <Header title={'Campaign Created List'}/>

            <div className="common_page_scroller mt-5 pe-2">
            <div className='bottom_btn_comp my-0'>
  <button type='button' className='btn bottom_btn'onClick={() => setShowHideDiv(false)}>Back</button>
  </div>
            <div className="page_header">
        </div>
                <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                    config={configdata}
                    records={viewDetails}
                    columns={columns1}
                />
                </div>
            </div>
                      <Button
                          className="gas_btn mr-3 text-white"
                          variant="contained"
                          color="secondary"
  
                      >
                        Polygon Gas Amount in <span className='redclrs'> $ {Totalvalue}</span>
                          {/* {`Polygon Gas Amount in $ ${Totalvalue}`} */}
                      </Button>
                      <Button
                          className="gas_btn mr-3 text-white" 
                          variant="contained"
                          color="secondary"
  
                      >
                        Ethereum Gas Amount in <span className='redclrs'> $ {Totalvalue1}</span>
                          {/* {`Ethereum Gas Amount in $ ${Totalvalue1}`} */}
                      </Button>
                      <Button
                          className="gas_btn mr-3 text-white"
                          variant="contained"
                          color="secondary"
                      >
                        Camino Gas Amount in <span className='redclrs'> $ {Totalvalue2}</span>
                          {/* {`Camino Gas Amount in $ ${Totalvalue2}`} */}
                      </Button>
                      <Button
                          className="gas_btn mr-3 text-white"
                          variant="contained"
                          color="secondary"
  
                      >
                        Total Gas Amount in <span className='redclrs'> $ {Totalvaluefinal}</span>
                          {/* {`Total Gas Amount in $ ${Totalvaluefinal}`} */}
                      </Button>
  
                      <div className="bottom_btn_comp mt-4">
                              <Exportexcel excelData={exportdata} fileName={'users'} />
                              <Exportpdf pdfData={exportdata} fileName={'users'} />
                              <Exportcsv csvData={exportdata} fileName={'users'} />
                          </div>
                          </Col>
        </Row>
                          </Container>
                  </>
              }
          </>
  )
}

export default Domains